import React from "react";

function WhyChooseUsSection() {
  const features = [
    {
      icon: "far fa-chalkboard-teacher",
      title: "Expert Mentors",
      desc: "Learn from industry professionals with real-world experience.",
      delay: ".1s",
    },
    {
      icon: "far fa-video",
      title: "Lifetime Access",
      desc: "Access all your purchased courses anytime, anywhere.",
      delay: ".2s",
    },
    {
      icon: "far fa-graduation-cap",
      title: "Certified Courses",
      desc: "Get professional certificates to boost your career.",
      delay: ".3s",
    },
    {
      icon: "far fa-clock",
      title: "Flexible Learning",
      desc: "Learn at your own pace with structured lessons.",
      delay: ".4s",
    },
  ];

  return (
    <div className="choose-area py-100">
      <div className="container">
        
        {/* Section Title */}
        <div className="site-title text-center mb-50">
          <h2 className="mb-20">
            Why <span className="text-gradient">Choose Us</span>
          </h2>
          <p>We provide the best learning experience for all learners.</p>
        </div>

        {/* Features Grid */}
        <div className="row g-4 justify-content-center">
          {features.map((item, index) => (
            <div className="col-12 col-sm-6 col-lg-3" key={index}>
              <div
                className="choose-box text-center shadow-sm wow fadeInUp"
                data-wow-delay={item.delay}
                style={{
                  padding: "30px 20px",
                  borderRadius: "12px",
                  background: "#fff",
                  transition: "0.3s",
                }}
              >
                {/* Icon */}
                <div
                  className="choose-icon mb-3"
                  style={{
                    fontSize: "45px",
                    color: "#6C63FF",
                  }}
                >
                  <i className={item.icon}></i>
                </div>

                {/* Title */}
                <h4
                  style={{ fontWeight: "600", fontSize: "20px", marginBottom: "8px" }}
                >
                  {item.title}
                </h4>

                {/* Description */}
                <p style={{ color: "#666", fontSize: "15px" }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default WhyChooseUsSection;
